const routes = [
  {
    path: "/configuracoes/caixas",
    component: () => import("@/views/configuracoes/caixas/Caixas.vue"),
    meta: {
      menu: "configuracoes",
      title: { text: "global.caixa", plural: true },
      icon: "mdi-cash-multiple",
      breadcrumb: [
        { text: "global.home", to: { path: "/" } },
        { text: "global.caixa", plural: true },
      ],
      permission: { componente: "Caixas" },
    },
  },
];

export default routes;
